import { zodValidator } from '@tanstack/zod-adapter';
import { Report } from '@anytag/app';
import { ReportSearchSchema } from '@anytag/shared-organisms';
import { PartialRouter } from '../../types';

export const ReportRouter = {
  '/_private-routes/report': [Report, { validateSearch: zodValidator(ReportSearchSchema) }]
} as const satisfies PartialRouter;
